import z from "zod";

import { ShiftSchemaResponse } from "./shift";

// Minimal Offer schema for embedding (expand as needed)
const OfferSchema = z
  .object({
    id: z.number(),
    offer_status: z.string(),
    // Add more fields as needed
  })
  .passthrough();

export const AssignmentSchema = z.object({
  createdAt: z.string(),
  updatedAt: z.string(),
  deletedAt: z.string().nullable(),
  id: z.number(),
  shift: ShiftSchemaResponse,
  business: z.any(), // Use Business if you want to be strict
  worker: z
    .object({
      full_name: z.string().optional(),
      // Add more fields as needed
    })
    .optional(),
  offer: OfferSchema.optional(),
  wage: z.number(),
  business_id: z.number(),
  worker_id: z.string(),
  start_date_time: z.string(),
  end_date_time: z.string(),
  wage_unit: z.string(),
  assignment_status: z.enum([
    "INIT",
    "IN_PROGRESS",
    "COMPLETED",
    "CANCELLED",
    "NO_SHOW",
  ]),
});

export type Assignment = z.infer<typeof AssignmentSchema>;

export const AssignmentListSchemaResponse = z.object({
  message: z.string().nullable(),
  success: z.boolean().default(false),
  assignments: z.array(AssignmentSchema),
  total: z.number(),
});

export type AssignmentListResponse = z.infer<
  typeof AssignmentListSchemaResponse
>;
